/* hydrus-gift-sync.js  (Alfred, 2026-10-14)
 * Fall Deals: every qualifying board gets its own free gift (pump or paddle).
 * The Shopify BXGY discounts already repeat per board (usesPerOrderLimit = none), but the
 * cart only had as many gift units as were added from the product page. Changing a board's
 * quantity in the drawer or on /cart left the gift at 1. This keeps the gift count equal to the
 * board count:
 *   - UP:   if the gift is already in the cart and there are more qualifying boards than gifts.
 *           (If the shopper removed the gift on purpose, we leave it out.)
 *   - DOWN: if there are more gifts than qualifying boards AND no other boards in the cart
 *           (other boards may carry the same add-on as a paid extra, so we never touch those).
 * Turns itself off at the Fall Deals end (epoch 1794380399 = Nov 10 2026 11:59:59 pm MT).
 * Teardown: operations/promotions/fall-deals-surfacing-2026-10/TEARDOWN-AND-REDO.md
 */
(function () {
  if (window.__hydrusGiftSync) return; window.__hydrusGiftSync = true;
  var END_MS = 1794380399 * 1000;
  // BFCM 2026 (Nov 20 00:00 MT to Dec 1 11:59:59 pm MT): one free gift (pump OR paddle) per board.
  var BFCM_START_MS = 1795158000 * 1000, BFCM_END_MS = 1796194799 * 1000;
  function bfcmOn() { var n = Date.now(); return n >= BFCM_START_MS && n <= BFCM_END_MS; }
  function fallOn() { return Date.now() <= END_MS; }
  if (!fallOn() && !bfcmOn() && Date.now() > BFCM_END_MS) return;
  var RULES = [
    { gift: 'shark-3-mini-electric-pump-addon',
      boards: ['all-around-inflatable-paddleboard-joyridexl', 'touring-inflatable-paddleboard-paradise',
               'inflatable-party-board-14x54', 'sale-inflatable-surfboard-hyper-isurf-58x24',
               'axis98-whitewater-river-sup', 'elysium-air-inflatable-race-board',
               'presale-axis88-river-sup-and-surf-board', 'presale-paradise-x-paddle-board-inflatable'] },
    { gift: 'adjustable-carbon-paddle-for-paddleboarding',
      boards: ['all-around-inflatable-paddleboard-joyride'] }
  ];
  var BOARD_TYPES = ['ISUP', 'SUP', 'Surf'];
  var busy = false, timer = null;

  var GIFTS = ['shark-3-mini-electric-pump-addon', 'adjustable-carbon-paddle-for-paddleboarding'];
  function planBfcm(cart) {
    // Gift count follows board count across both gifts. Only grows if a gift is already in the cart
    // (a shopper who removed it on purpose is left alone). Never removes a gift: a second one may be a paid add-on.
    var boards = 0, g = 0, giftLines = [];
    cart.items.forEach(function (it) {
      if (GIFTS.indexOf(it.handle) !== -1) { g += it.quantity; giftLines.push(it); }
      else if (BOARD_TYPES.indexOf(it.product_type) !== -1) boards += it.quantity;
    });
    var target = null;
    if (g >= 1 && g < boards) target = boards;
    if (target === null || target === g || !giftLines.length) return null;
    var last = giftLines[giftLines.length - 1];
    return { key: last.key, quantity: Math.max(0, last.quantity + (target - g)) };
  }

  function plan(cart) {
    if (bfcmOn()) return planBfcm(cart);
    if (!fallOn()) return null;
    for (var r = 0; r < RULES.length; r++) {
      var rule = RULES[r], q = 0, other = 0, g = 0, giftLines = [];
      cart.items.forEach(function (it) {
        if (it.handle === rule.gift) { g += it.quantity; giftLines.push(it); }
        else if (rule.boards.indexOf(it.handle) !== -1) q += it.quantity;
        else if (BOARD_TYPES.indexOf(it.product_type) !== -1) other += it.quantity;
      });
      var target = null;
      if (g >= 1 && g < q) target = q;
      else if (g > q && other === 0) target = q;
      if (target !== null && target !== g) {
        var last = giftLines[giftLines.length - 1];
        var newQty = Math.max(0, last.quantity + (target - g));
        return { key: last.key, quantity: newQty };
      }
    }
    return null;
  }

  async function sync() {
    if (busy || (!fallOn() && !bfcmOn())) return;
    busy = true;
    try {
      var cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      var p = plan(cart);
      if (p) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: p.key, quantity: p.quantity }) });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'gift-sync' } }));
      }
    } catch (e) { /* never block the cart */ }
    busy = false;
  }

  document.addEventListener('cart:refresh', function (e) {
    var origin = e.detail && e.detail.source;
    if (origin === 'gift-sync') return;
    clearTimeout(timer); timer = setTimeout(sync, 350);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
